import { Nullable } from '@ps/utils';

export interface TrackerWaveSequenceEntry {
  readonly waveId: number;
  readonly dateTimeInIso: Nullable<string>;
}

export function isTrackerWaveSequenceValid(
  entries: readonly TrackerWaveSequenceEntry[],
): boolean {
  const sorted = [...entries].sort((left, right) => left.waveId - right.waveId);

  return sorted.every((entry, index) => {
    if (index === 0) {
      return true;
    }
    const previous = sorted[index - 1];
    return (
      entry.waveId > previous.waveId &&
      dateOf(entry.dateTimeInIso) >= dateOf(previous.dateTimeInIso)
    );
  });
}

function dateOf(dateTimeInIso: Nullable<string>): number {
  return dateTimeInIso ? Date.parse(dateTimeInIso) : Date.now();
}
